// import React from 'react';

// import o1 from '../../static/lifeat1.jpg';
// import o2 from '../../static/lifeat2.jpg';
// import o3 from '../../static/lifeat3.jpg';
// import o4 from '../../static/lifeat4.jpg';
// import o5 from '../../static/o2.jpg';
// import './css/lifeatimzi.css';

// export default function LfieImzi() {
//   return (
//     <div>
//       <div className='h-28 bg-cyan overflow-x-hidden'>
//         <h2
//           className='text-center my-7 overline text-xl lg:text-3xl text-white'
//           data-aos='zoom-in'
//           data-aos-delay='50'
//           data-aos-duration='1000'
//         >
//           IHCA Office Culture and Environment
//         </h2>
//       </div>

//       <div className='bg-cyan'>
//         <div className='grid grid-cols-2
        
        
//          sm:grid-cols-2 md:grid-cols-2 gap-4 mx-auto max-w-5xl'>
//           <div
//             className='my-2 '
//             data-aos='zoom-in'
//             data-aos-delay='50'
//             data-aos-duration='1000'
//           >
//             <img className='h-auto rounded-lg' src={o5} alt='' />
//           </div>
//           <div
//             className='my-2 '
//             data-aos='zoom-in'
//             data-aos-delay='40'
//             data-aos-duration='800'
//           >
//             <img className='h-auto rounded-lg' src={o2} alt='' />
//           </div>
//           <div
//             className='my-2 '
//             data-aos='zoom-in'
//             data-aos-delay='40'
//             data-aos-duration='800'
//           >
//             <img className='h-auto rounded-lg' src={o3} alt='' />
//           </div>
//           <div
//             className='my-2 '
//             data-aos='zoom-in'
//             data-aos-delay='40'
//             data-aos-duration='800'
//           >
//             <img className='h-auto rounded-lg' src={o4} alt='' />
//           </div>
//           <div
//             className='my-2 flex justify-center col-span-2'
//             data-aos='zoom-in'
//             data-aos-delay='20'
//             data-aos-duration='400'
//           >
//             <img className=' h-36 sm:h-80 md:h-96 rounded-lg' src={o1} alt='' />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import { useNavigate } from "react-router";

export default function UnderConstruction({
  title = "Under Construction",
  message = "We’re currently improving this page to deliver a better experience. Please check back shortly.",
}) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 px-4">
      
      <div className="text-center max-w-md w-full animate-fade-in">

        {/* SVG Icon */}
        <div className="flex justify-center mb-6">
          <div className="p-4 rounded-2xl bg-blue-50">
            <svg
              className="w-12 h-12 text-blue-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v4m0 4h.01"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold text-slate-800 mb-3">
          {title}
        </h1>

        {/* Message */}
        <p className="text-slate-600 text-lg mb-6 leading-relaxed">
          {message}
        </p>

        {/* Divider */}
        <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 mx-auto rounded-full mb-8"></div>

        {/* Action */}
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-blue-600 text-white font-medium shadow hover:bg-blue-700 transition-all"
        >
          {/* Arrow SVG */}
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>

          Go Back
        </button>
      </div>
    </div>
  );
}